<div class="record-list-content">
  <!-- Header -->
  <div class="header">
    <div class="title">Records/Schedule</div>
    <div class="description">Create and manage your records here</div>
  </div>
  <!-- Search -->
  <div class="header-search">
    <div class="filters">
      <div class="filter-item" [class.selected]="!filter" (click)="filterRecord(null)">All</div>
      <div class="filter-item" [class.selected]="filter === 'upcomming'" (click)="filterRecord('upcomming')">Upcoming</div>
      <div class="filter-item" [class.selected]="filter === 'inprogress'" (click)="filterRecord('inprogress')">In Progress</div>
      <div class="filter-item" [class.selected]="filter === 'completed'" (click)="filterRecord('completed')">Completed</div>
    </div>
    <div class="search"></div>
    @if (permissions | includesBy: 'record:create') {
      <div class="button" [class.disabled]="!project" (click)="createRecord()">Create</div>
    }
  </div>
  <!-- Records -->
  <div class="records">
    @for (record of dataSource.filteredData; track record.id) {
      <a [routerLink]="[record.id]" class="record" [ngClass]="record?.status">
        <div class="info">
          <div class="title">
            <div class="name">{{ record?.title }}</div>
            @if (record.status) {
              <div class="record-status" [ngClass]="record?.status">{{ record?.status }}</div>
            }
          </div>
          <div class="date">
            <div class="day">{{ recordDateInfo[record.id!].displayDate }}</div>
            <div class="time">{{ recordDateInfo[record.id!].start }} {{ recordDateInfo[record.id!].end }}</div>
          </div>
        </div>
        @if (record.servers) {
          <div class="deliverables">
            @for (server of record.servers; track server.id) {
              @for (channel of server.channels; track channel) {
                <div class="delivery">
                  <div class="format">{{ channel.format }}</div>
                  <!-- <div class="destinations">{{ delivery.destinations.join(', ') }}</div> -->
                  <div class="destinations">{{ server.name }}</div>
                </div>
              }
            }
          </div>
        }
        <div class="actions">
          @if (permissions | includesBy: 'record:delete') {
            <div class="delete">
              <mat-icon svgIcon="trash" class="icon" (click)="deleteRecord(record, $event)"></mat-icon>
            </div>
          }
        </div>
      </a>
    } @empty {
      <div class="empty-list">No records</div>
    }
  </div>
</div>